import { createColumnHelper, Row } from '@tanstack/react-table';

import { PoliceReportLookup } from '../../services/types/police-report-types';

const columnHelper = createColumnHelper<PoliceReportLookup>();

const ArrayFilter = (
  row: Row<PoliceReportLookup>,
  columnId: string,
  filterValue: string[],
) => {
  return filterValue.includes(row.getValue(columnId));
};

export const usePoliceReportsColumns = () => [
  columnHelper.accessor('matter_name', {
    header: 'Matter',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('firm_name', {
    header: 'Firm',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('search_details.state', {
    header: 'State',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('search_details.jurisdiction', {
    header: 'Jurisdiction',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('search_details.last_name', {
    header: 'Last Name',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('search_details.incident_date', {
    header: 'Incident Date',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: (info) => info.getValue(),
    filterFn: ArrayFilter,
    enableColumnFilter: true,
    enableSorting: true,
  }),
];
